import { render, staticRenderFns } from "./InvoiceStore.vue?vue&type=template&id=22971bd6"
import script from "./InvoiceStore.vue?vue&type=script&lang=js"
export * from "./InvoiceStore.vue?vue&type=script&lang=js"
import style0 from "./InvoiceStore.vue?vue&type=style&index=0&id=22971bd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports